"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFacct = void 0;
var _utils_1 = require("../_utils");
var _1 = require(".");
var methods_to_call_1 = require("../_utils/methods-to-call");
var geo_utils_1 = require("@portals/geo-utils");
var settingsByEnv = {
    prod: {
        backUrl: (0, geo_utils_1.resolveUrl)("//seller-services.wildberries.ru/sec/api/fl"),
        cid: "w-wb",
        disableRequestOnPageUnload: true,
    },
    stage: {
        backUrl: (0, geo_utils_1.resolveUrl)("//seller-services-stage.wildberries.ru/sec/api/fl"),
        cid: "w-wb-t",
        disableRequestOnPageUnload: true
    },
    dev: {
        backUrl: "/external-api-seller-services/sec/api/fl",
        cid: "w-wb-t",
        disableRequestOnPageUnload: true
    },
};
var initFacct = function (env) {
    (0, _utils_1.registerScript)({
        // TODO Возможно заливать скрипт из репы пакета, а не руками
        src: (0, geo_utils_1.resolveUrl)("https://static-basket-02.wbbasket.ru/vol20/sec/0.0.1/facct/b5d2d550-f02a-11ee-84a1-b22d46000000.js"),
        onLoad: function () {
            (0, _1.callWindowGib)(function () {
                var _a;
                console.log("call window.gib.init");
                (_a = window.gib) === null || _a === void 0 ? void 0 : _a.init(settingsByEnv[env] || settingsByEnv["prod"]);
            });
            if (methods_to_call_1.facctMethods.methodsToCall.length > 0) {
                console.log("process delayed calls to window.gib");
                methods_to_call_1.facctMethods.methodsToCall.forEach(function (m) {
                    m();
                });
            }
        },
    });
};
exports.initFacct = initFacct;
